<mat-progress-bar *ngIf="loading"
  mode="indeterminate"></mat-progress-bar>
<button (click)="pickFile()"
  mat-flat-button>
        Upload a File
      </button>
<input (change)="fileChange($event)"
  [style.visibility]="loading ? 'hidden' : 'visible'"
  #fileInput
  type="file">